import { useCountUp } from '@/lib/useCountUp';

/** A number that climbs to its new value rather than jumping. */
export function CountUp({
  value,
  className = '',
  signed = false,
}: {
  value: number;
  className?: string;
  signed?: boolean;
}) {
  const shown = useCountUp(value);
  const text = signed && shown > 0 ? `+${shown}` : String(shown);

  // The final value is what a screen reader should hear, not each frame.
  return (
    <span className={className}>
      <span aria-hidden>{text}</span>
      <span className="sr-only">{signed && value > 0 ? `+${value}` : value}</span>
    </span>
  );
}
